
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/law-dissertation-planning",
      function () {
        return require("private-next-pages/resources/law-dissertation-planning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/law-dissertation-planning"])
      });
    }
  